export enum ScheduleType {
  CHECKUP = 'CH',
  CONSULTATION = 'C',
  EXAM = 'E',
  SERVICE = 'S',
  SURGERY = 'Y',
  CHEMOTHERAPY = 'Q',
  REQUEST = 'R',
  WAITING_LIST = 'W',
  CHECKUP_TYPE = 'CTE'
}
